import React from "react";
import Tenants from "../components/pages/Tenants/Tenants";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const ContentLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <Tenants />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ContentLayout;
